// src/utils/fingerprint.js
import FingerprintJS from '@fingerprintjs/fingerprintjs';

const STORAGE_KEY = 'fp_device_uuid';

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function getStoredUUID() {
  try {
    return localStorage?.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function storeUUID(uuid) {
  try {
    localStorage?.setItem(STORAGE_KEY, uuid);
    return true;
  } catch {
    return false;
  }
}

async function isValidFp(expectedFp) {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const fingerprintHash = result.visitorId;

    // Check if expectedFp is part of the fingerprint hash
    const isValid = expectedFp.includes(fingerprintHash)// fingerprintHash.includes(expectedFp);

    // console.log('Fingerprint validation:', {
    //   expected: fingerprintHash,
    //   actual: expectedFp,
    //   isValid: isValid,
    //   matchType: isValid ? 'partial' : 'none'
    // });

    return isValid;
  } catch (error) {
    console.error('Fingerprint validation failed:', error);
    return false;
  }
}

export async function getFingerprint() {
  try {
    // Return stored UUID if exists
    const storedUUID = getStoredUUID();
    if (storedUUID) {
      if (isValidFp(storedUUID))
        return storedUUID;
    }

    // Generate new fingerprint and UUID
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const fingerprintHash = result.visitorId;

    // Create combined ID and store it
    const uuid = generateUUID();
    const combinedId = `${fingerprintHash}-${uuid}`;

    storeUUID(combinedId);
    return combinedId;

  } catch (error) {
    console.error("Fingerprint error:", error);

    // Fallback to stored UUID or generate temporary one
    return getStoredUUID() || generateUUID();
  }
}